import React from 'react';
import { Box, Typography } from '@mui/material';

import { getActiveScheduleLineGroup } from '../../../../store/selectors/scheduleStationSelectors';
import { useAppSelector } from '../../../hooks';

export function SidebarContextPanel(props: { type: string; name: string }) {
  return (
    <Box sx={{ marginX: 2, marginTop: 1 }}>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        {props.type}
      </Typography>

      <Typography variant="h6">{props.name}</Typography>
    </Box>
  );
}

export function ScheduleLineGroupPanel() {
  const context = useAppSelector((state) => state.application.openContext);

  const stations = useAppSelector((state) => state.stations);
  const activeGroup = useAppSelector(getActiveScheduleLineGroup);

  if (context?.type !== 'schedule-station') return null;

  if (activeGroup != null) {
    return <SidebarContextPanel type="Schedule Line Group" name={activeGroup.name} />;
  }

  const station = stations[context.stationGuid];
  if (station != null) {
    return <SidebarContextPanel type="Schedule Station" name={station.name} />;
  }

  return null;
}
